export const WorkflowTreeConstants = {
  WorkflowTreeNodeTypes:
  {
    Process: 'Process',
    Folder: 'Folder',
    JobList: 'JobList',
    FilteredView: 'FilteredView'
  }
};